/*
 * COPYRIGHT © 2026 SANITÀNEXUS WHITE-LABEL. ALL RIGHTS RESERVED.
 * AUTHOR AND SOLE DEVELOPER: MARCO PANZETTI (C.F. PNZMRC89M14F251C)
 * Protected under Italian Copyright Law (Legge 633/1941) and International Treaties.
 * Unauthorized copying, reverse engineering, or distribution of this software architecture,
 * UI/UX layouts, local-first logic, or system prompt configurations is strictly prohibited.
 */
import React from 'react';
import { Check, X } from 'lucide-react';
import {
  Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle, DialogDescription,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { REGISTRY_LABEL } from './PendingVerificationCard';

/**
 * Full-size preview of the registry evidence with quick approve/reject shortcuts.
 * Extracted from AdminOnboardingPanel.jsx (Phase 8 refactor).
 */
const EvidenceZoomDialog = ({ open, user, onClose, onQuickApprove, onQuickReject }) => (
  <Dialog open={open && !!user} onOpenChange={(o) => { if (!o) onClose(); }}>
    <DialogContent className="max-w-3xl" data-testid="admin-onb-evidence-dialog">
      <DialogHeader>
        <DialogTitle>Registry evidence — {user?.full_name || user?.email}</DialogTitle>
        <DialogDescription>
          {REGISTRY_LABEL[user?.registry_type] || user?.registry_type} · N° {user?.registry_number}
        </DialogDescription>
      </DialogHeader>
      {user?.registry_evidence_data_url && (
        <div className="max-h-[70vh] overflow-auto bg-secondary/30 rounded-lg p-2">
          <img
            src={user.registry_evidence_data_url}
            alt="Registry evidence full size"
            className="w-full h-auto rounded"
          />
        </div>
      )}
      <DialogFooter className="gap-2 flex-wrap">
        <Button variant="ghost" onClick={onClose}>Close</Button>
        <Button
          variant="destructive"
          onClick={onQuickReject}
          data-testid="admin-onb-evidence-reject"
        >
          <X className="h-4 w-4 mr-1" /> Reject
        </Button>
        <Button onClick={onQuickApprove} data-testid="admin-onb-evidence-approve">
          <Check className="h-4 w-4 mr-1" /> Approve
        </Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);

export default EvidenceZoomDialog;
